'use client';
import Nodata from "@/components/shared/no-data/Nodata";
import { useCartContext } from "@/providers/CartContext";
import {Link} from "@/i18n/routing";
import { useState } from "react";
import {useTranslations} from 'next-intl';
import {useSearchParams} from 'next/navigation';
import CartProductItem from '@/components/shared/cart/CartProductItem';
import CouponCodeField from '@/components/shared/cart/CouponCodeField';
import CartTotalTable from '@/components/sections/cart/CartTotalTable';
import {PRIVATE_ROUTE_NAME} from '@/libs/constants/common.constants';

export default function CartPrimary({ autoUseCoupon, firstOrderCoupon }) {
  const t = useTranslations('checkout');
  const searchParams = useSearchParams();
  const { cartProducts, cartTotalPrice, deleteProductFromCart, addProductToCart } = useCartContext();
  
  const [newCoupon, setNewCoupon] = useState(null);
  
  const onManipulateQuantity = async ({ product, quantity, price }) => {
    if (!Array.isArray(cartProducts) && cartProducts.length === 0) return;
    
    const foundProductCart = cartProducts.find(pr => pr.product.id === product.id);
    if (!foundProductCart) return;
    
    addProductToCart(product, quantity, true, false);
    // changeTotalPrice(product, price);
  }
  
  const onDeleteProduct = async (product, price) => {
    deleteProductFromCart(product.id, false);
    // data.items = data.items.filter(d => d.product.id !== product.id);
    // changeTotalPrice(product, price);
  }
  
  return (
    <div className="liton__shoping-cart-area mb-50">
      <div className="container">
        <div className="mini-cart-product-area ltn__scrollbar">
          {
            Array.isArray(cartProducts) && cartProducts.length > 0 ? (
                <>
                  {
                    cartProducts.map(({product, quantity}, idx) => {
                      return (
                          <div key={idx} className="mini-cart-item clearfix account-cart">
                            <CartProductItem
                                product={product}
                                quantity={quantity}
                                onDeleteProduct={onDeleteProduct}
                                type="cart"
                                onManipulateQuantity={onManipulateQuantity}
                            />
                          </div>
                      );
                    })
                  }
                  <CouponCodeField
                      newCoupon={newCoupon}
                      setNewCoupon={setNewCoupon}
                  />
                  <div className="shoping-cart-total mt-50">
                    <h4>{t('cartTotals')}</h4>
                    <CartTotalTable
                        newCoupon={newCoupon}
                        autoUseCoupon={autoUseCoupon}
                        totalPrice={{common: cartTotalPrice, sale: 0}}
                    />
                    <div className="btn-wrapper text-right">
                      <Link
                          href={`/checkout${searchParams.has('coupon') ? `?coupon=${searchParams.get('coupon')}` : ''}`}
                          className="theme-btn-1 btn btn-effect-1"
                      >
                        {t('proceedCheckout')}
                      </Link>
                    </div>
                    <div className="checkout-discount-hint">
                      {
                        t.rich('wantToGetMoreDiscount', {
                          a: (chunks) => (<Link href={`${PRIVATE_ROUTE_NAME}?tab=cart`} className="link-color fw-bold">{chunks}</Link>),
                        })
                      }
                      {' '}
                      {
                        firstOrderCoupon ? (
                            t.rich('firstOrderDiscountGift', {
                              b: (chunks) => (<b>{chunks}</b>),
                              i: (chunks) => (<i>{chunks}</i>),
                              discount: firstOrderCoupon.discount * 100
                            })
                        ) : ''
                      }
                    </div>
                  </div>
                </>
            ) : (<Nodata text={t('emptyCart')}/>)
          }
        </div>
      </div>
    </div>
  );
};
